import { Macro } from '../types/Macro';
import { MacroParts } from '../types/MacroParts';
import { macroPartsToMacro } from './macroPartsToMacro';

export const segmentsToString = (segments: (string | Macro | MacroParts)[]) => {
  const strSegments: string[] = [];

  for (const item of segments) {
    if (!item) continue;
    if (typeof item === 'string') {
      strSegments.push(item);
      continue;
    }
    strSegments.push(macroPartsToMacro(item).segment);
  }

  return strSegments.join(' ') + ' ';
};
